export default "__VITE_ASSET__DxTwaIyv__"